// Universal links (iOS) → ruta interna de la app. Lógica pura, sin Capacitor.
//
// Por qué: el link de WhatsApp /portal/t/<token> debe abrir la APP si está
// instalada (apple-app-site-association en /.well-known + entitlement
// applinks). Capacitor entrega la URL por el evento appUrlOpen (y por
// App.getLaunchUrl() en arranque en frío); aquí se decide a qué ruta ir.
// Solo rutas del CLIENTE: el resto de la app no se abre por link.

const ALLOWED = [
    /^\/portal\/t\/[^/]+$/,            // capability link
    /^\/portal\/[0-9a-f-]{36}$/i,      // legacy /portal/<uuid> (resuelve token)
    /^\/customer-login$/,
    /^\/feedback\/[^/]+$/,
];

/** URL absoluta (https) → path interno permitido, o null. */
export function deepLinkToPath(url) {
    try {
        const u = new URL(String(url || ''));
        if (!/^https?:$/.test(u.protocol)) return null;
        const path = u.pathname.replace(/\/+$/, '') || '/';
        if (!ALLOWED.some(rx => rx.test(path))) return null;
        return `${path}${u.search || ''}`;
    } catch {
        return null;
    }
}
